import { render, staticRenderFns } from "./IndexHomeRating.vue?vue&type=template&id=685def71"
import script from "./IndexHomeRating.vue?vue&type=script&lang=js"
export * from "./IndexHomeRating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports